import { createAction, props } from "@ngrx/store";
import { ApplicationResponseDto } from "src/app/application/shared/services/backend/response/create-application-response.dto";
import { ExceptionResponseDto } from "src/app/shared/services/backend/shared/exceptions/exception-response.dto";
import { NavigationParameters } from "src/app/shared/store/shared/navigation-parameters";

import { Product } from "../shared/product";

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Business Actions (those type of actions are initially dispatched)
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const createApplication = createAction(
  "[Application] [Business] Create Application",
  props<CreateApplicationParameters>(),
);

export const getApplication = createAction(
  "[Application] [Business] Get Application",
  props<GetApplicationParameters>(),
);

export const resetApplicationError = createAction(
  "[Application] [Business] Reset Application Error",
);

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Chain Reaction Action (those type of actions are never directly dispatched but are triggered as a result of a business action)
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// GET
export const getApplicationStart = createAction(
  "[Application] [Backend] Get Application (start)",
  props<GetApplicationParameters>(),
);

export const getApplicationSuccess = createAction(
  "[Application] [Backend] Get Application (success)",
  props<ApplicationResponseDto>(),
);

export const getApplicationFail = createAction(
  "[Application] [Backend] Get Application (fail)",
  props<ExceptionResponseDto>(),
);

export const getApplicationCancel = createAction(
  "[Application] [Backend] Get Application (cancel)",
);

// CREATE
export const createApplicationStart = createAction(
  "[Application] [Backend] Create Application (start)",
  props<CreateApplicationParameters>(),
);

export const createApplicationSuccess = createAction(
  "[Application] [Backend] Create Application (success)",
  props<ApplicationResponseDto & NavigationParameters>(),
);

export const createApplicationFail = createAction(
  "[Application] [Backend] Create Application (fail)",
  props<ExceptionResponseDto>(),
);

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Models
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export interface CreateApplicationParameters extends NavigationParameters {
  quoteId: string;
  product: Product;
}

export interface GetApplicationParameters {
  applicationId: string;
  product: Product;
}
